import React from "react";
import FieldInput from "./FieldInput";
import { buildFieldKey } from "./useSectionRequirement";
import FileUpload from "../../../components/ui/inputs/fileUpload/FileUpload";
import Buttons from "../../../components/ui/button/Buttons";

const RequirementCard = ({
    item,
    reqData,
    matchedFields,
    brandList,
    fieldsState,
    isFieldInvalid,
    caseOfficerComments,
    peerReviewerComments,
    status,
    onCommentChange,
    onSave,
    saveLoading,
    isLocked = true,
    extraClass = "",
}) => {
    const renderFieldRow = (field, brand) => {
        const rawFieldId = field.sgbpAdditionalFieldInputId;
        const brandId = brand?.id ?? null;
        const key = buildFieldKey(rawFieldId, brandId);
        const invalid = isFieldInvalid(key, field.isRequired);
        const fieldState = fieldsState?.[key];

        return (
            <React.Fragment key={key}>
                {brand && (
                    <div className="left column">
                        <label>
                            <span style={{ fontSize: "16px", color: "#000000", fontWeight: "500" }}>Brand: </span>
                            <span> {brand.brand}</span>
                        </label>
                        <label className="mt-4">
                            <span style={{ fontSize: "16px", color: "#000000", fontWeight: "500" }}>Model: </span>
                            <span> {brand.model}</span>
                        </label>
                    </div>
                )}
                <div className={brand ? "left column" : "left"}>
                    <label>
                        {field?.label ?? ""} {field?.isRequired && <span className="red-star">*</span>}
                    </label>
                    <label className="mt-4 instruction-content">
                        <div dangerouslySetInnerHTML={{ __html: field?.addtionalFieldIntruction || "" }} />
                    </label>
                </div>
                <div className={brand ? "right column" : "right"}>
                    <FieldInput field={field} value={fieldState?.value} invalid={invalid} isLocked={isLocked} />
                    <textarea
                        disabled
                        placeholder=""
                        value={fieldState?.comment || ""}
                        style={isLocked ? { background: "#f5f5f5", cursor: "not-allowed" } : {}}
                    />
                </div>
            </React.Fragment>
        );
    };

    return (
        <div className={`evaluation-table ${extraClass}`.trim()}>
            <div className="table-header">
                <div>{item.requirementName}</div>
                <div>Documents to Upload</div>
                <div>Submission</div>
            </div>

            <div className="table-body">
                <div className="column instruction-content">
                    <div dangerouslySetInnerHTML={{ __html: item?.requirementDescription || "" }} />
                </div>

                <div className="column instruction-content">
                    <div dangerouslySetInnerHTML={{ __html: item?.requirementToBeSubmitted || "" }} />
                </div>

                <div className="column submission">
                    {isLocked && (
                        <span style={{ color: "#f52828", fontSize: "18px", display: "block", marginBottom: "6px" }}>
                            🔒 This requirement is locked.
                        </span>
                    )}
                    <FileUpload
                        name="uploadFile"
                        isButtonVisible={true}
                        isDownloadButton={true}
                        acceptedFiles=".jpg,.jpeg,.png,.webp,.svg,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,.json,.xml,.zip,.rar"
                        maxFileSizeInKB={5000}
                        buttonText="Upload"
                        isDisable={isLocked}
                    />

                    <div className="files">
                        {(reqData?.files || []).map((f) => (
                            <p key={f.id} className="file-item">
                                <span className="file-name" style={{ cursor: isLocked ? "not-allowed" : "pointer" }}>
                                    {f.name}
                                </span>
                                <span className="delete-file" style={{ cursor: isLocked ? "not-allowed" : "pointer" }}>
                                    Delete
                                </span>
                            </p>
                        ))}
                    </div>

                    <label>Comment</label>
                    <textarea disabled placeholder="" value={reqData?.comment || ""} />
                </div>

                {matchedFields.length > 0 &&
                    (brandList?.length > 0 ? (
                        matchedFields.map((field) => brandList.map((brand) => renderFieldRow(field, brand)))
                    ) : (
                        <div className="row">
                            <div className="form-block">{matchedFields.map((field) => renderFieldRow(field, null))}</div>
                        </div>
                    ))}
            </div>

            <div className="status-bar">
                <span>Status</span>
                <span>{status || ""}</span>
                <span></span>
            </div>
            <div className="commant-box">
                <label>Case Officer Clarification Comments (External)</label>
                <textarea placeholder="SGBC Comments" disabled value={caseOfficerComments || ""} />
            </div>
            <div className="commant-box pt-0">
                <label>Peer Reviewer/Final Approver Comments (Internal)</label>
                <textarea
                    placeholder="SGBC Comments"
                    // disabled
                    value={peerReviewerComments || ""}
                    onChange={(e) => onCommentChange(e.target.value)}
                />
            </div>
            <div className="form-actions w-full">
                <Buttons
                    buttonText="Save"
                    buttonTypeClassName="ml-auto success-btn"
                    onClick={onSave}
                    isLoading={saveLoading}
                    isDisable={saveLoading}
                />
            </div>
        </div>
    );
};

export default RequirementCard;